import React, { useEffect, Suspense } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './i18n';
import Router from './Router';
import { setUserToken, setUuid } from './features/signup/signupSlice';
import { selectActivePage } from './features/ui/uiSlice';
import ReactGA from 'react-ga4';
import { REACT_APP_GOOGLE_ADS_ID, REACT_APP_GOOGLE_TRACKING_ID } from './analytics/GA';
import { oneLinkSmartScript } from './scripts/onLink';
import { useInlineScript } from './helper/useInlineScript';
import * as Sentry from '@sentry/react';
import GlobalStyle from './globalStyles';
import UIAlert from './UI/Alert';
import Loader from './UI/Loader';
import Layout from './UI/Layout';
import ProgrBar from './UI/ProgrBar';


const App = () => {
    const dispatch = useDispatch();
    const activePage = useSelector(selectActivePage);

    useInlineScript(oneLinkSmartScript, 'AF_SMART_SCRIPT');

    useEffect(() => {
        const setDynamicVH = () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        setTimeout(() => {
            setDynamicVH();
            window.addEventListener('resize', setDynamicVH, false);
        },1000);
        return () => window.removeEventListener('resize', setDynamicVH, false);
    }, []);

    useEffect(() => {
        const storageToken = window.sessionStorage?.getItem('access_token');

        if (storageToken) {
            dispatch(setUserToken(storageToken))
        }

        dispatch(setUuid());
    }, [dispatch]);

    useEffect(() => {
        const initOptionsList = [
            { trackingId: REACT_APP_GOOGLE_TRACKING_ID },
            { trackingId: REACT_APP_GOOGLE_ADS_ID },
        ];
        if (REACT_APP_GOOGLE_TRACKING_ID && REACT_APP_GOOGLE_ADS_ID) {
            ReactGA.initialize(initOptionsList);
        }
    }, []);

    return (
        <Suspense fallback={<Loader />}>
            <GlobalStyle/>
            <Loader showMessage={true}/>
            <Layout activePage={activePage}>
                <ProgrBar />
                <BrowserRouter>
                    <Route path={['/']} component={Router}/>
                </BrowserRouter>
            </Layout>
            <UIAlert/>
        </Suspense>
    )
};

export default Sentry.withProfiler(App);
